/**
 * Format Management Functions
 * وظائف إدارة Formats (16:9, 9:16, 1:1, etc.)
 */

/**
 * Format resolution mapping
 */
export const formatResolutions = {
  '16:9': { width: 1920, height: 1080, name: 'YouTube' },
  '16/9': { width: 1920, height: 1080, name: 'YouTube' },
  '9:16': { width: 1080, height: 1920, name: 'Shorts' },
  '9/16': { width: 1080, height: 1920, name: 'Shorts' },
  '1:1': { width: 1080, height: 1080, name: 'Square' },
  '1/1': { width: 1080, height: 1080, name: 'Square' },
  '4:5': { width: 1080, height: 1350, name: 'Portrait' },
  '4/5': { width: 1080, height: 1350, name: 'Portrait' },
  '21:9': { width: 2560, height: 1080, name: 'Cinematic' },
  '21/9': { width: 2560, height: 1080, name: 'Cinematic' },
  '3:2': { width: 1620, height: 1080, name: 'Photo' },
  '3/2': { width: 1620, height: 1080, name: 'Photo' }
};

/**
 * Get format resolution
 * @param {string} aspectRatio - Aspect ratio (e.g., '16:9')
 * @returns {Object} Resolution object with width, height, name
 */
export const getFormatResolution = (aspectRatio) => {
  return formatResolutions[aspectRatio] || formatResolutions['16:9'];
};

/**
 * Build format filters for FFmpeg
 * @param {Object} format - Format object
 * @returns {Array} FFmpeg filter array
 */
export const buildFormatFilters = (format) => {
  if (!format || !format.aspectRatio) {
    return []; // No format specified
  }
  
  const resolution = getFormatResolution(format.aspectRatio);
  if (!resolution) {
    console.warn('⚠️ Unknown aspect ratio:', format.aspectRatio);
    return [];
  }
  
  const { width, height } = resolution;
  
  // Basic scaling and cropping filter
  const videoFilter = `scale=${width}:${height}:force_original_aspect_ratio=increase,crop=${width}:${height}`;
  
  console.log(`🎯 Format filter: ${format.aspectRatio} -> ${width}x${height} (${resolution.name})`);
  
  return ['-vf', videoFilter];
};

/**
 * Apply format to export options
 * @param {Object} exportOptions - Export options
 * @param {Object} format - Format object
 * @returns {Object} Updated export options
 */
export const applyFormatToExport = (exportOptions, format) => {
  if (!format) {
    return exportOptions;
  }
  
  const formatFilters = buildFormatFilters(format);
  if (formatFilters.length > 0) {
    exportOptions.formatFilters = formatFilters;
    exportOptions.format = format;
  }
  
  return exportOptions;
};

/**
 * Get available formats list
 * @returns {Array} List of available formats
 */
export const getAvailableFormats = () => {
  return [
    { id: '16:9', label: 'YouTube', icon: 'Youtube', resolution: '1920x1080' },
    { id: '9:16', label: 'Shorts', icon: 'Smartphone', resolution: '1080x1920' },
    { id: '1:1', label: 'Square', icon: 'Square', resolution: '1080x1080' },
    { id: '4:5', label: 'Portrait', icon: 'Instagram', resolution: '1080x1350' },
    { id: '21:9', label: 'Cinematic', icon: 'Monitor', resolution: '2560x1080' },
    { id: '3:2', label: 'Photo', icon: 'Image', resolution: '1620x1080' }
  ];
};

